// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as Config from "../../../../../Config.bs.js";
import * as OrderStage from "../../../ticket-dashboard/app/tickets/entities/OrderStage.bs.js";
import * as CountryConfig from "../../../../../library/data-source/country-config/app/entity/CountryConfig.bs.js";
import * as Network$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/helper-modules/response-handler/Network.bs.js";
import * as ApiUtils$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.bs.js";
import * as NetworkV2$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/helper-modules/response-handler/NetworkV2.bs.js";
import * as RaiseTicketRepoConfig from "./RaiseTicketRepoConfig.bs.js";
import * as CreateTicketEntityMapper from "../entity-mapper/CreateTicketEntityMapper.bs.js";

function raiseTicket(ticket, country) {
  var requestUrl = Config.Env.getHostName(undefined) + "/administrators/ticketing/create_ticket_v2";
  var encodedPayload = JSON.stringify(CreateTicketEntityMapper.execute(ticket));
  return Network$Catalyst.postRequestV2(requestUrl, encodedPayload, {
                country: CountryConfig.countryToString(country)
              }, undefined, undefined).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(RaiseTicketRepoConfig.CreateTicketResponseConverter.execute, result);
                        });
            });
}

function fetchTicketInfo(crn, country) {
  var requestUrl = Config.Env.getHostName(undefined) + ("/administrators/ticketing/new?crn=" + crn);
  return NetworkV2$Catalyst.get(requestUrl, {
                country: CountryConfig.countryToString(country)
              }, undefined, undefined, /* Include */2, undefined).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(RaiseTicketRepoConfig.TicketInfoResponseConverter.execute, result);
                        });
            });
}

function fetchTicketIssues(orderStage, _country) {
  var requestUrl = Config.Env.getCrmGatewayUrl(undefined) + "/api/v1/issues/get?order_call_stage=" + OrderStage.toString(orderStage);
  return NetworkV2$Catalyst.get(requestUrl, undefined, undefined, undefined, /* Include */2, undefined).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(RaiseTicketRepoConfig.TicketIssuesResponseConverter.execute, result);
                        });
            });
}

function fetchTicketActions(orderStage, _country) {
  var requestUrl = Config.Env.getCrmGatewayUrl(undefined) + "/api/v1/actions/get?order_call_stage=" + OrderStage.toString(orderStage);
  return NetworkV2$Catalyst.get(requestUrl, undefined, undefined, undefined, /* Include */2, undefined).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(RaiseTicketRepoConfig.TicketActionsResponseConverter.execute, result);
                        });
            });
}

function fetchTicketIssuesV2(orderStage, _country) {
  var requestUrl = Config.Env.getCrmGatewayUrl(undefined) + "/api/v1/issues/get?order_call_stage=" + OrderStage.toString(orderStage);
  return NetworkV2$Catalyst.get(requestUrl, undefined, undefined, undefined, /* Include */2, undefined).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(RaiseTicketRepoConfig.TicketIssuesV2ResponseConverter.execute, result);
                        });
            });
}

var RaiseTicketRepo = {
  raiseTicket: raiseTicket,
  fetchTicketInfo: fetchTicketInfo,
  fetchTicketIssues: fetchTicketIssues,
  fetchTicketActions: fetchTicketActions,
  fetchTicketIssuesV2: fetchTicketIssuesV2
};

export {
  RaiseTicketRepo ,
  
}
/* Config Not a pure module */
